module.exports = __webpack_public_path__ + "media/ubud/waterfall2-ec88b27d.jpg";